import { ActionTypes } from "store/constants";

const chatStatePayload = {
  open: false,
};

export const chatState = (state = chatStatePayload, action) => {
  switch (action.type) {
    case ActionTypes.chat.openChat:
      return { ...state, open: action.payload };
    default:
      return state;
  }
};
